import { validate } from 'vue-convenia-util'

/**
 * Obtém um FormData cujas entradas são as propriedades do objeto.
 * @param {object} [object]
 * @returns {FormData}
 */
export const toFormData = (object = {}) => {
  const entries = Object.entries(object)
  const form = entries.reduce((form, [ property, value ]) => {
    form.append(property, value)
    return form
  }, new FormData())
  return form
}

const makeArrayKey = (key, index) => {
  return key.length > 2 && key.lastIndexOf('[]') === key.length - 2
    ? key
    : [key, '[', index, ']'].join('')
}

/**
 * Obtém um FormData cujas entradas são as propriedades do objeto complexo, recursivamente.
 * @param {obj} [object]
 * @param {form} [object]
 * @param {namespace} [string]
 * @returns {FormData}
 */
export const toDeepFormData = (obj = {}, fd, pre) => {
  fd = fd || new FormData()
  Object.keys(obj).forEach(prop => {
    const key = pre ? [pre, '[', prop, ']'].join('') : prop
    const is = {
      array: validate.is(obj[prop], 'Array'),
      object: validate.is(obj[prop], 'Object'),
      file: obj[prop] instanceof File
    }
    if (is.object && !is.array && !is.file) {
      toDeepFormData(obj[prop], fd, key)
    } else if (is.array) {
      if (!obj[prop].length) {
        fd.append(prop + '', '')
        return
      }
      obj[prop].forEach((value, index) => {
        const arrayKey = makeArrayKey(key, index)
        const valueIs = {
          object: validate.is(value, 'Object'),
          file: value instanceof File
        }
        if (valueIs.object && !valueIs.file) {
          toDeepFormData(value, fd, arrayKey)
        } else {
          fd.append(arrayKey, value)
        }
      })
    } else {
      fd.append(key, obj[prop])
    }
  })
  return fd
}



// WEBPACK FOOTER //
// ./src/helpers/cast.js